/**
 * flair_history stores DATE as a calendar day (YYYY-MM-DD), not an instant in time.
 * `new Date('2026-04-02')` is parsed as UTC midnight → wrong local day in US timezones.
 * These helpers use local date components so charts match the DB day everywhere.
 */
export function parseSqlDateStringLocal(isoDate: string): Date {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(isoDate).trim());
  if (!m) return new Date(NaN);
  const y = parseInt(m[1], 10);
  const mo = parseInt(m[2], 10) - 1;
  const d = parseInt(m[3], 10);
  return new Date(y, mo, d);
}

/** Format tick from chart x-value (ms from parseSqlDateStringLocal). */
export function formatTrendTickFromMs(
  ms: number,
  timeBucket: '30days' | '1year' | 'all'
): string {
  const date = new Date(ms);
  if (Number.isNaN(date.getTime())) return '';
  if (timeBucket === 'all') {
    const y = date.getFullYear();
    const mo = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${mo}-${d}`;
  }
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}
